import { F0Alert, F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface Props {
  isOpen: boolean
  candidateUrls: string[]
  settingThumbnail: boolean
  error: string | null
  onPick: (index: number) => void
  onClose: () => void
}

const ScormThumbnailPicker = ({
  isOpen,
  candidateUrls,
  settingThumbnail,
  error,
  onPick,
  onClose,
}: Props) => (
  <F0Dialog
    isOpen={isOpen}
    onClose={onClose}
    title={i18n.t('trainings.scorm.thumbnail.picker_title')}
  >
    <F0Box display="flex" flexDirection="column" gap="md">
      {error && <F0Alert variant="critical" title={error} description="" />}
      <F0Text content={i18n.t('trainings.scorm.thumbnail.picker_description')} variant="body" />
      <F0Box display="flex" flexDirection="row" flexWrap="wrap" gap="md" justifyContent="center">
        {candidateUrls.map((url, index) => (
          <F0Box key={url} display="flex" flexDirection="column" gap="sm" alignItems="center">
            <img
              src={url}
              alt={i18n.t('trainings.scorm.thumbnail.candidate_alt', { number: index + 1 })}
              width={200}
              height={150}
              role="button"
              tabIndex={settingThumbnail ? -1 : 0}
              style={{
                objectFit: 'cover',
                borderRadius: 8,
                cursor: settingThumbnail ? 'not-allowed' : 'pointer',
              }}
              onClick={() => {
                if (!settingThumbnail) onPick(index)
              }}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (!settingThumbnail && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault()
                  onPick(index)
                }
              }}
            />
          </F0Box>
        ))}
      </F0Box>
      {settingThumbnail && (
        <F0Box display="flex" justifyContent="center">
          <Spinner />
        </F0Box>
      )}
    </F0Box>
  </F0Dialog>
)

export default ScormThumbnailPicker
